import { ref } from 'vue'

export interface ConfirmOptions {
  title?: string
  message: string
  confirmLabel?: string
  cancelLabel?: string
  variant?: 'default' | 'danger'
}

interface ConfirmState extends Required<ConfirmOptions> {
  open: boolean
  resolve: (value: boolean) => void
}

const state = ref<ConfirmState>({
  open: false,
  title: '',
  message: '',
  confirmLabel: 'OK',
  cancelLabel: 'Abbrechen',
  variant: 'default',
  resolve: () => {},
})

export function useConfirm() {
  function confirm(options: ConfirmOptions): Promise<boolean> {
    return new Promise((resolve) => {
      state.value = {
        open: true,
        title: options.title ?? '',
        message: options.message,
        confirmLabel: options.confirmLabel ?? 'Bestätigen',
        cancelLabel: options.cancelLabel ?? 'Abbrechen',
        variant: options.variant ?? 'default',
        resolve,
      }
    })
  }

  function handle(value: boolean) {
    state.value.resolve(value)
    state.value.open = false
  }

  return { state, confirm, handle }
}
